import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const icon = props => (
    <SvgIcon {...props}>
        <path d="M 4 4 C 2.895 4 2 4.895 2 6 L 2 18 C 2 19.105 2.895 20 4 20 L 20 20 C 21.105 20 22 19.105 22 18 L 22 6 C 22 4.895 21.105 4 20 4 L 4 4 z M 10 8 C 10.733 8 11.411953 8.2106875 12.001953 8.5546875 C 12.592953 8.2116875 13.269 8 14 8 C 16.206 8 18 9.794 18 12 C 18 14.206 16.206 16 14 16 C 13.269 16 12.592953 15.789312 12.001953 15.445312 C 11.411953 15.789312 10.733 16 10 16 C 7.791 16 6 14.209 6 12 C 6 9.791 7.791 8 10 8 z M 14 10 C 13.821 10 13.651328 10.030219 13.486328 10.074219 C 13.804328 10.648219 14 11.298 14 12 C 14 12.702 13.804328 13.351781 13.486328 13.925781 C 13.651328 13.969781 13.821 14 14 14 C 15.103 14 16 13.103 16 12 C 16 10.897 15.103 10 14 10 z"></path>
    </SvgIcon>
);

export default icon;
